import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=435043ba&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=435043ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435043ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435043ba')) {
      api.createRecord('435043ba', component.options)
    } else {
      api.reload('435043ba', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=435043ba&scoped=true&", function () {
      api.rerender('435043ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/nftCollectionMarket/widget.vue"
export default component.exports